import { FC, ReactElement, memo, useMemo } from 'react';
import { TBooleanInNumber } from '~/types/main';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';
import { itemsInventoryAvailableEdit, itemsInventoryPosSetting } from '~/view/screens/ItemsInventoryScreen/helpers/itemsInventory';

export const ItemsInventorySwitcherType = {
  STOCK: 'stock',
  STATUS: 'status',
} as const;
export type TItemsInventorySwitcherType = TValueOf<typeof ItemsInventorySwitcherType>;

interface IProps {
  type: TItemsInventorySwitcherType;
  status: TBooleanInNumber;
  onChange: (value: TBooleanInNumber) => void;
  isCombo: boolean;
  branchFilterId: number;
}

export const ItemsInventoryListItemSwitcher: FC<IProps> = memo((props: IProps): ReactElement => {
  const { type, status, isCombo, branchFilterId } = props;

  const posSetting = useMemo(() => itemsInventoryPosSetting({ type, isCombo, branchFilterId }), [type, isCombo, branchFilterId]);
  const availableEdit = useMemo(() => itemsInventoryAvailableEdit(type), [type]);

  return (
    <IntegrationManager setting={posSetting} wrapperClassName="items-inventory-list-item__element" withTooltip>
      <Switcher status={status} disabled={!availableEdit} onChange={props.onChange} />
    </IntegrationManager>
  );
});
